import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { UserLoginView } from "@app/data/authentication/models/user-login-view";
import { OAuthTokenResponse } from "@app/data/shared/models/oauth-token-response";
import { GrantType } from "@app/data/authentication/enums/auth-grant-type.enum";
import { Observable, throwError } from "rxjs";
import { delay, tap } from "rxjs/operators";

@Injectable()
export class AuthService {
  private static basicAuthCredits = {
    username: "PROVIDER",
    password: "KLSPHERE1453!@",
  };
  private static basicAuthHash = btoa(
    `${AuthService.basicAuthCredits.username}:${AuthService.basicAuthCredits.password}`
  );
  private static headers: HttpHeaders = new HttpHeaders().set(
    "Authorization",
    "Basic " + AuthService.basicAuthHash
  );
  protected refresh_token: string;

  static getAuthToken(): string {
    return localStorage.getItem("access_token");
  }

  static setAuthToken(token: string) {
    localStorage.setItem("access_token", token);
  }

  static logout(callback: Function) {
    localStorage.clear();
    if (document.getElementsByTagName("html")[0].hasAttribute("dir")) {
      document.getElementsByTagName("html")[0].removeAttribute("dir");
    }
    callback();
    return throwError("logout");
  }

  protected authUrl() {
    return localStorage.getItem("authUrl")
      ? localStorage.getItem("authUrl")
      : environment.authUrl;
  }

  protected apiUrl() {
    return localStorage.getItem("apiUrl")
      ? localStorage.getItem("apiUrl")
      : environment.apiUrl;
  }

  constructor(private http: HttpClient) {}

  login(user: UserLoginView): Observable<OAuthTokenResponse> {
    const transformedUser = new FormData();
    transformedUser.append("username", user.username);
    transformedUser.append("password", user.password);
    transformedUser.append("grant_type", user.grant_type);
    return this.http.post<OAuthTokenResponse>(
      `${this.authUrl()}/oauth/token`,
      transformedUser,
      { headers: AuthService.headers }
    );
  }

  forgotPassword(payload): Observable<any> {
    return this.http.post(`${this.apiUrl()}/password/forgot`, payload);
  }

  resetPassword(payload): Observable<any> {
    return this.http.post(`${this.apiUrl()}/password/reset`, payload);
  }

  setPassword(link, payload): Observable<any> {
    return this.http.post(`${this.apiUrl()}/` + link, payload);
  }

  changePassword(payload): Observable<any> {
    return this.http.post(`${this.apiUrl()}/password/change`, payload);
  }

  refreshToken(): Observable<OAuthTokenResponse> {
    const token = localStorage.getItem("refresh_token");
    const tokenBody = new FormData();
    tokenBody.append("grant_type", GrantType.REFRESH_TOKEN);
    tokenBody.append("refresh_token", token);
    return this.http
      .post<OAuthTokenResponse>(`${this.authUrl()}/oauth/token`, tokenBody, {
        headers: AuthService.headers,
      })
      .pipe(
        delay(200),
        tap((response) => {
          AuthService.setAuthToken(response.access_token);
        })
      );
  }
}
